import React from 'react';
import c1 from '../media/sleepingbag1.jpg';
import c2 from '../media/mosquitonet.jpg';
import c3 from '../media/pillow.jpg';
import c4 from '../media/c4.webp';
import c5 from '../media/drysheet.png';
import c6 from '../media/c6.webp';
import { Link, useNavigate } from 'react-router-dom';

const categories = [
  { title: 'Baby Organic Cotton Sleeping Bags', image: c1, cat: "Sleeping Bags" },
  { title: 'Baby Organic Cotton  Foldable Mosquito Nets', image: c2, cat: "Baby Mosquito Net" },
  { title: "Kidorise Newborn's Head-Shaping Mustard Pillow", image: c3, cat: "Pillows" },
  { title: 'Baby Waterproof Protector Dry Sheets', image: c5, cat: "Dry Sheet" },
];

function FeaturedCat() {
  const navigate = useNavigate();
  return (
    <section id="feature" className="feature">
      <div className="container">
        <div className="section-header">
          <h2 style={{ marginBottom: '0', marginTop: '4rem' }}>Featured Categories</h2>
        </div>
        <div className="feature-content">
          <div className="row">
            {categories.map((cat, index) => (
              <div className="col-sm-3 col-xs-6" key={cat._id} onClick={()=> navigate(`/collection/${cat.cat}`) }>
                <div className="single-feature">
                  <img src={cat.image} alt={`${cat.title} image`} />
                  <div className="single-feature-txt text-center">
                    <h3><Link to={`/collection/${cat.cat}`}>{cat.title}</Link></h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default FeaturedCat;
